import moment from 'moment'
import { isWx, isVzanApp } from '@/utils/utils'
import storeConfigModel from '@/controllers/storeController/view/store/storeConfig.model'

export const AGENT_STATE = {
  0: 'VERIFYING', // 待审核
  1: 'INUSE', // 正常
  2: 'REFUSE', // 审核拒绝
  3: 'DISCHARGE', // 禁用
  VERIFYING: 0,
  INUSE: 1,
  REFUSE: 2,
  DISCHARGE: 3,
  NOAUDIT: -1, // 没权限
}

// 配送方式列表
export const DELIVERY_LIST = [
  {
    value: -1,
    name: '全部',
  },
  {
    value: 1,
    name: '物流配送',
  },
  {
    value: 2,
    name: '门店自提',
  },
  {
    value: 10,
    name: '常规核销',
  },
  {
    value: 11,
    name: '门店核销',
  },
]

// 优惠券状态列表
export const COUPON_LIST = [
  {
    value: 0,
    name: '全部',
  },
  {
    value: 1,
    name: '未核销',
  },
  {
    value: 2,
    name: '已核销',
  },
  {
    value: 3,
    name: '已过期',
  },
  {
    value: 4,
    name: '已失效',
  },
]

// 选择题字母表
export const LETTER_MAP = [
  {
    label: 'A',
    value: 1,
  },
  {
    label: 'B',
    value: 2,
  },
  {
    label: 'C',
    value: 3,
  },
  {
    label: 'D',
    value: 4,
  },
  {
    label: 'E',
    value: 5,
  },
  {
    label: 'F',
    value: 6,
  },
  {
    label: 'G',
    value: 7,
  },
  {
    label: 'H',
    value: 7,
  },
]

// 题目类型组件
export const QUESTION_COMPONENT = {
  1: 'SingleChoice',
  2: 'MultipleChoice',
  4: 'JudgeQuestion',
}

// 下单时间类型列表
export const ORDER_TIME_TYPE = [
  {
    value: 1,
    name: '今日',
  },
  {
    value: 3,
    name: '近3天',
  },
  {
    value: 7,
    name: '近7天',
  },
  {
    value: 30,
    name: '近30天',
  },
  {
    value: -1,
    name: '自定义',
  },
]

// 日期近期列表
export const RECENTLY_DATE_LIST = [
  {
    value: [
      moment(new Date()).format('YYYY-MM-DD 00:00:00'),
      moment(new Date()).format('YYYY-MM-DD 23:59:59'),
    ],
    name: '今日',
  },
  {
    value: [
      moment(new Date())
        .subtract(3 - 1, 'days')
        .format('YYYY-MM-DD 00:00:00'),
      moment(new Date()).format('YYYY-MM-DD 23:59:59'),
    ],
    name: '近 3 天',
  },
  {
    value: [
      moment(new Date())
        .subtract(7 - 1, 'days')
        .format('YYYY-MM-DD 00:00:00'),
      moment(new Date()).format('YYYY-MM-DD 23:59:59'),
    ],
    name: '近 7 天',
  },
  {
    value: [
      moment(new Date())
        .subtract(30 - 1, 'days')
        .format('YYYY-MM-DD 00:00:00'),
      moment(new Date()).format('YYYY-MM-DD 23:59:59'),
    ],
    name: '近 30 天',
  },
]

export const DATE_KEY_LIST = [
  {
    value: 1,
    name: '领取时间',
  },
  // {
  //   value: 2,
  //   name: '使用时间',
  // },
]
export const DATE_DETAIL_KEY_LIST = [
  {
    value: 1,
    name: '领取时间',
  },
  {
    value: 2,
    name: '核销时间',
  },
]

// 日期筛选列表
export const DATE_LIST = [
  {
    value: [
      moment(new Date()).format('YYYY-MM-DD'),
      moment(new Date()).format('YYYY-MM-DD'),
    ],
    name: '今日',
  },
  {
    value: [
      moment(new Date())
        .subtract(3 - 1, 'days')
        .format('YYYY-MM-DD'),
      moment(new Date()).format('YYYY-MM-DD'),
    ],
    name: '最近3天',
  },
  {
    value: [
      moment(new Date())
        .subtract(7 - 1, 'days')
        .format('YYYY-MM-DD'),
      moment(new Date()).format('YYYY-MM-DD'),
    ],
    name: '最近7天',
  },
  {
    value: [
      moment(new Date())
        .subtract(30 - 1, 'days')
        .format('YYYY-MM-DD'),
      moment(new Date()).format('YYYY-MM-DD'),
    ],
    name: '最近一个月',
  },
  {
    value: [],
    name: '自定义',
    label: '自定义',
  },
]

// 优惠券详情查询状态
export function getCouponDetailStateList() {
  return [
    {
      value: '',
      name: '全部',
      isShow: true,
    },
    {
      value: 1,
      name: this.lineType == 0 ? '未核销' : '未使用',
      isShow: true,
    },
    {
      value: 2,
      name: this.lineType == 0 ? '已核销' : '已使用',
      isShow: true,
    },
    {
      value: 3,
      name: '已过期',
      isShow: true,
    },
    {
      value: 4,
      name: '已失效',
      isShow: true,
    },
    {
      value: 5,
      name: '未生效',
      isShow: true,
    },
  ]
}

// 优惠券类型
export const COUPON_LINE_TYPE = [
  {
    value: 0,
    name: '核销优惠券',
  },
  {
    value: 1,
    name: '观看优惠券',
  },
  {
    value: 2,
    name: '商品优惠券',
  },
]

// 推广直播列表操作栏
const ACTION_TYPE = {
  WORK_WX_GROUP_SEND: 1, // 企微群发
  SHARE_H5_PAGE: 2, // 分享h5页面
  SHARE_MINI_APP: 201, // 分享小程序
  ENTER_H5_PAGE: 3, // 进入h5页面
  ENTER_MINI_APP: 301, // 进入小程序
  ANSWER_GIFT_SETTING: 4, // 答题有礼设置
  ANSWER_GIFT_DATA: 5, // 答题有礼数据
  TEAM_DATA: 6, // 团队数据
  WATCHING_REWARD_SETTING: 7, // 观看奖励设置
  WATCHING_REWARD_DATA: 8, // 观看奖励数据
  COMMUNITY_RED_ENVELOPES: 9, // 社群红包
  ORDER_DATA: 10, // 订单数据
  SET_PLAY_BACK_TIME: 800, // 设置回放时间
  LUCKYBAG_DATA: 999, // 福袋数据
}
export function agentTopicActionList() {
  return [
    {
      id: ACTION_TYPE.WORK_WX_GROUP_SEND,
      text: '企微群发',
      fn: 'handleCwxMass',
      isShow: this.agentCenter.country == 'WorkWeiXin',
    },
    {
      id: ACTION_TYPE.SHARE_H5_PAGE,
      text: '分享H5海报',
      fn: 'shareLive',
      isShow: this.isOpenAgtShare,
    },
    {
      id: ACTION_TYPE.SHARE_MINI_APP,
      text: '分享小程序',
      fn: 'shareMiniApp',
      isShow:
        this.isOpenMiniShare &&
        this.curItem.miniAppTranspond &&
        (isVzanApp() || isWx()),
    },
    {
      id: ACTION_TYPE.ENTER_H5_PAGE,
      text: '进入直播间',
      fn: 'enterLive',
      isShow: true,
    },
    {
      id: ACTION_TYPE.ENTER_MINI_APP,
      text: '进入小程序',
      fn: 'enterMiniApp',
      isShow: this.isOpenMiniShare && (isVzanApp() || isWx('nowork')),
    },
    {
      id: ACTION_TYPE.ANSWER_GIFT_SETTING,
      text: '答题有礼设置',
      fn: 'agentRedEnvelopeSet',
      isShow:
        this.curTpAgentPayInfo &&
        this.agentRedShow &&
        this.actState === 0 &&
        this.redType === 1 &&
        this.payType === 11,
    },
    {
      id: ACTION_TYPE.ANSWER_GIFT_DATA,
      text: '答题有礼数据',
      fn: 'agentRedEnvelopeData',
      isShow: this.curTpAgentPayInfo && this.agentRedShow && this.actState,
    },
    {
      id: ACTION_TYPE.WATCHING_REWARD_SETTING,
      text: '观看奖励设置',
      fn: 'watchingRewardAgentRedEnvelopeSet',
      isShow: this.rewardSetShow,
    },
    {
      id: ACTION_TYPE.WATCHING_REWARD_DATA,
      text: '观看奖励数据',
      fn: 'showWatchingRewardData',
      isShow: this.rewardDataShow,
    },
    {
      id: ACTION_TYPE.TEAM_DATA,
      text: '团队数据',
      fn: 'teamData',
      storeZbCheck: true,
      isShow:
        (this.isAdmin && !this.agentAuthData.isAgent) ||
        (this.agentAuthData.level > 1 && this.agentAuthData.isAgent),
    },
    {
      id: ACTION_TYPE.COMMUNITY_RED_ENVELOPES,
      text: '社群红包',
      fn: 'socialRedEnvelope',
      storeZbCheck: true,
      isShow: this.getIsAgentGray
        ? this.getSocialRedEnvelope
        : this.communityRed,
    },
    {
      id: ACTION_TYPE.ORDER_DATA,
      text: '订单数据',
      fn: 'orderData',
      storeZbCheck: true,
      isShow: this.getIsAgentGray ? this.getOrderListDetail : true,
    },
    {
      id: ACTION_TYPE.SET_PLAY_BACK_TIME,
      text: '设置回放时间',
      fn: 'setPlayBackTime',
      isShow: this.curItem.playBackIsShow,
    },
    {
      id: ACTION_TYPE.LUCKYBAG_DATA,
      text: '福袋数据',
      fn: 'showLuckyBagData',
      isShow: this.luckyBagDataShow,
    },
  ]
}
// 订单类型
export const ORDER_TYPE_LIST = [
  {
    value: null,
    name: '全部',
  },
  {
    value: 200,
    name: '普通商品',
  },
  {
    value: 1227,
    name: '闪购商品',
  },
  {
    value: 240,
    name: '直播间秒杀',
  },
  {
    value: 1212,
    name: '商品拼团',
  },
  {
    value: 1288,
    name: '满减/满折',
  },
  {
    value: 1211,
    name: '预约金商品',
  },
  {
    value: 1806,
    name: '集卡换奖励',
  },
  {
    value: 1807,
    name: '积分商城',
  },
  {
    value: 1808,
    name: '会员卡订单',
  },
  {
    value: 1315,
    name: '社群接龙',
  },
  {
    value: 1316,
    name: '福袋活动',
  },
  {
    value: 1230,
    name: '补款订单',
  },
]

// 下单日期类型
export const ORDER_DATE_TYPE_LIST = [
  {
    name: '下单时间',
    value: 'orderTime',
  },
  {
    name: '退款时间',
    value: 'refundTime',
  },
  {
    name: '收货时间',
    value: 'receiveTime',
  },
]

// 配送枚举
export const DELIVERY_TYPE = {
  STORE_PICKUP: 1, // 门店自提
  COMMODITY_DISTRIBUTION: 2, // 商品配送
}

// 订单状态列表
export const ORDER_LIST = [
  {
    value: -999,
    name: '全部',
  },
  {
    value: 0,
    name: '未付款',
    key: 'noPay',
    isShow: false,
    deliveryType: DELIVERY_TYPE.COMMODITY_DISTRIBUTION,
  },
  {
    value: 1,
    name: '待发货',
    key: 'noShipments',
    isShow: true,
    deliveryType: DELIVERY_TYPE.COMMODITY_DISTRIBUTION,
    isDefault: true,
  },
  {
    value: 5,
    name: '待收货',
    key: 'shipped',
    isShow: true,
    deliveryType: DELIVERY_TYPE.COMMODITY_DISTRIBUTION,
    isDefault: true,
  },
  {
    value: 10,
    name: '已完成',
    key: 'finish',
    isShow: true,
    deliveryType: DELIVERY_TYPE.COMMODITY_DISTRIBUTION,
    isDefault: true,
  },
  {
    value: 16,
    name: '已退款',
    key: 'refund',
    isShow: false,
    deliveryType: DELIVERY_TYPE.COMMODITY_DISTRIBUTION,
  },
  {
    value: -1,
    name: '取消交易',
    key: 'cancel',
    isShow: false,
    deliveryType: DELIVERY_TYPE.COMMODITY_DISTRIBUTION,
  },
  {
    value: 1,
    tipWord:
      '未核销不含已退款、退款中的商品，指在所筛选时间的订单中至今仍未被核销的商品的核销状态',
    name: '未核销',
    key: 'unVerified',
    isShow: true,
    deliveryType: DELIVERY_TYPE.STORE_PICKUP,
    isDefault: true,
  },
  {
    value: 2,
    tipWord:
      '已核销不含已退款、退款中的商品，指在所筛选时间的订单中至今已经被核销的商品的核销状态',
    name: '已核销',
    key: 'verified',
    isShow: true,
    deliveryType: DELIVERY_TYPE.STORE_PICKUP,
    isDefault: true,
  },
  {
    value: 3,
    tipWord:
      '已过期不含已退款、退款中的商品，指在所筛选时间的订单中至今已经过期的商品的核销状态',
    name: '已过期',
    key: 'expired',
    isShow: true,
    deliveryType: DELIVERY_TYPE.STORE_PICKUP,
    isDefault: true,
  },
  {
    hasDetail: true,
    value: 5,
    name: '退款中',
    key: 'refunding',
    isShow: true,
    deliveryType: DELIVERY_TYPE.STORE_PICKUP,
    isDefault: true,
  },
  {
    hasDetail: true,
    value: 4,
    name: '已退款',
    key: 'invalid',
    isShow: true,
    deliveryType: DELIVERY_TYPE.STORE_PICKUP,
    isDefault: true,
  },
]

// 核销状态
export const VERIFY_STATUS = [
  {
    name: '未核销',
    value: 1,
  },
  {
    name: '已核销',
    value: 2,
  },
  {
    name: '已过期',
    value: 3,
  },
  {
    name: '已退款',
    value: 4,
  },
  {
    name: '退款中',
    value: 5,
  },
]

// 核销状态
export const VERIFY_STATUS_LIST = [
  {
    value: -1,
    name: '全部',
  },
  {
    value: 1,
    name: '未核销',
  },
  {
    value: 4,
    name: '已核销',
  },
  {
    value: 2,
    name: '部分核销',
  },
  {
    value: 9,
    name: '已退款',
  },
  {
    value: 7,
    name: '已过期',
  },
  {
    value: 8,
    name: '部分退款',
  },
  {
    value: 6,
    name: '退款中',
  },
  {
    value: 5,
    name: '部分过期',
  },
  // {
  //   value: 4,
  //   name: '已退款'
  // }
]
// 核销提示
export const HX_TIPS = [
  '未核销：订单中所有的核销码都为未核销',
  '已核销：订单中所有的核销码都为已核销',
  '部分核销：订单中的核销码只有未核销/已核销',
  '已退款：订单中所有的核销码都为已退款',
  '已过期：订单中所有的核销码都为已过期',
  '部分退款：订单中有任意一个核销码为已退款状态，但并非全部核销码都为已退款状态（优先级较【退款中】、【部分过期】都高）',
  '退款中：订单中任意一个核销码为退款中的状态（优先级较【部分过期】高）',
  '部分过期：订单中有任意一个核销码为已过期的状态，但并非全部核销码都为已过期状态',
]

// 时间筛选类型
export const TIME_TYPE_SELECT = [
  {
    name: '下单时间',
    value: 0,
  },
  {
    name: '收货时间',
    value: 1,
  },
  // {
  //   name: '退款时间',
  //   value: 'refundTime'
  // },
  // {
  //   name: '退款时间',
  //   value: 'receiveTime'
  // }
]

// 现金红包的支付方式
export const EPayType = {
  /** 代理支付 */
  ARENT_PAY: 11,
  /** 自有账户支付 */
  OWN_ACCOUNT_PAY: 2,
  /** 余额支付 */
  BALANCE_PAY: 4,
}
// 红包类型
export const ERedType = {
  /** 代理手动设置 */
  AGENT_SETTING: 1,
  /** 总部统一设置 */
  OFFICE_SETTING: 0,
}
// 代理中心权限 页面白名单
export const whitePathList = [
  '/agent/period',
  '/agent/warmPrompt',
  '/agent/errInfo',
  '/agent/error',
  '/agent/result',
  '/agent/apply',
  '/agent/newInviteCard',
  '/agent/sumVerify',
  '/agent/batchVerify',
  '/agent/verifyRecord',
  '/agent/activateAgent',
  '/agent/aliGuidePage',
  '/agent/agentBind',
].concat(storeConfigModel.STORE_WHITE_PATH_LIST)

// 客户码权限
export const CUSTOMER_CODE_STATE = {
  /** 正常查看 */
  AUDIT: 1,
  /** 非直播间的代理员、管理员、创建者 */
  NO_AGENT: 2,
  /** 代理员被禁用 */
  AGENT_FORDIDDEN: 3,
  /** 未绑定代理 */
  NOT_BOUND: 4,
  /** 直播间代理，但无权限查看 */
  NO_AUDIT: 5,
}
/** 大订单枚举 */
export const ORDER_TYPE_ENUM = {
  /** 内容订单 */
  contentOrder: 1,
  /** 商品订单 */
  productOrder: 2,
  /** 分销订单 */
  distributionOrder: 3,
}

/** 门店各字段信息 */
export const STORE_FIELDS_LIST = [
  {
    /** 前端数据结构的 key */
    key: 'groupId',
    /** 为空提示 */
    prompt: '请选择门店分类',
    /** 对应后端接口的 key */
    openKey: 'storeGroup',
    requiredKey: 'storeGroupIsRequire',
  },
  {
    key: 'title',
    prompt: '请输入门店名称',
    openKey: 'storeTitle',
    requiredKey: 'storeTitleIsRequire',
  },
  {
    key: 'provinceCode',
    prompt: '请选择门店所在省',
    openKey: 'storeArea',
    requiredKey: 'storeAreaIsRequire',
  },
  {
    key: 'cityCode',
    prompt: '请选择门店所在市',
    openKey: 'storeArea',
    requiredKey: 'storeAreaIsRequire',
  },
  {
    key: 'areaCode',
    prompt: '请选择门店所在区',
    openKey: 'storeArea',
    requiredKey: 'storeAreaIsRequire',
  },
  {
    key: 'address',
    prompt: '请输入门店详细地址',
    openKey: 'storeAddress',
    requiredKey: 'storeAddressIsRequire',
  },
  {
    key: 'tel',
    prompt: '请输入门店联系电话',
    openKey: 'storeTelephone',
    requiredKey: 'storeTelephoneIsRequire',
  },
  {
    key: 'teleUserName',
    prompt: '请输入门店联系人姓名',
    openKey: 'storeTeleUserName',
    requiredKey: 'storeTeleUserNameIsRequire',
  },
]
/** 代理中心权限code */
export const AGRNT_AUTH_CODE = {
  /** H5端代理中心底部导航栏 */
  BOTTOM_NAVIGATION_BAR: 'bottom_navigation_bar',
  /** 工作台 */
  WORKBENCH_NAVIGATION_BAR: 'workbench_navigation_bar',
  /** 直播推广 */
  LIVE_PROMOTION_NAVIGATION_BAR: 'live_promotion_navigation_bar',
  /** 栏目推广 */
  COLUMN_PROMOTION_NAVIGATION_BAR: 'column_promotion_navigation_bar',
  /** 我的 */
  MINE: 'mine',
  /** 工作台（PC端和H5端） */
  WORKBENCH: 'workbench',
  /** 数据概览 */
  DATA_OVERVIEW: 'data_overview',
  /** 汇总数据 */
  SUMMARY_DATA: 'summary_data',
  /** 引流 */
  DRAINAGE: 'drainage',
  /** 客户管理 */
  CUSTOMER_MANAGEMENT: 'customer_management',
  /** 消耗积分 */
  CONSUME_POINTS: 'consume_points',
  /** 发送积分 */
  SEND_POINTS: 'send_points',
  /** 拉黑 */
  DEFRIEND: 'defriend',
  /** 禁言 */
  FORBIDDEN_SPEECH: 'forbidden_speech',
  /** 解/换绑 */
  UNBIND_OR_REPLACE_BINDING: 'unbind_or_replace_binding',
  /** 会员查看 */
  MEMBERS_VIEW: 'members_view',
  /** 会员审核 */
  MEMBER_AUDIT: 'member_audit',
  /** 会员升降级 */
  MEMBER_PROMOTION_AND_DEMOTION: 'member_promotion_and_demotion',
  /** 会员移除 */
  MEMBER_DELETE: 'member_delete',
  /** 会员编辑 */
  MEMBER_EDIT: 'member_edit',
  /** 招募会员 */
  RECRUITING_MEMBERS: 'recruiting_members',
  /** 营销 */
  MARKETING: 'marketing',
  /** 直播推广 */
  LIVE_PROMOTION: 'live_promotion',
  /** 社群红包(直播推广下) */
  // LIVE_PROMOTION_COMMUNITY_RED_ENVELOPE:
  //   'live_promotion_community_red_envelope',
  /** 栏目推广 */
  COLUMN_PROMOTION: 'column_promotion',
  /** 商机管理 */
  OPPORTUNITY_MANAGEMENT: 'opportunity_management',
  /** 商品推广 */
  PRODUCT_PROMOTION: 'product_promotion',
  /** 社群红包 */
  COMMUNITY_RED_ENVELOPE: 'community_red_envelope',
  /** 集卡换奖励 */
  COLLECTING_CARDS_FOR_REWARDS: 'collecting_cards_for_rewards',
  /** 支付有礼 */
  PAY_WITH_GIFTS: 'pay_with_gifts',
  /** 积分商城 */
  POINTS_MALL: 'points_mall',
  /** 待办任务 */
  TO_DO_TASKS: 'to_do_tasks',
  /** 交易 */
  TRANSACTION: 'transaction',
  /** 订单统计 (交易) */
  ORDER_STATISTICS: 'order_statistics',
  /** 售后处理 */
  AFTER_SALES_PROCESSING: 'after_sales_processing',
  /** 商品统计(交易) */
  PRODUCT_STATISTICS: 'product_statistics',
  /** 优惠券统计(交易) */
  COUPON_STATISTICS: 'coupon_statistics',
  /** 在途配送(交易) */
  IN_TRANSIT_DELIVERY: 'in_transit_delivery',
  /** 交易投诉 */
  TRADING_COMPLAINTS: 'trading_complaints',
  /** 履约 */
  PERFORMANCE: 'performance',
  /** 核销工具 */
  SCAN_CODE_VERIFICATION: 'scan_code_verification',
  /** 核销记录（履约） */
  VERIFICATION_RECORD: 'verification_record',
  /** 提货单 */
  BILL_OF_LADING: 'bill_of_lading',
  /** 战绩 */
  COMBAT_GAINS: 'combat_gains',
  /** 经营报表 */
  BUSINESS_REPORT: 'business_report',
  /** 门店报表 */
  STORE_REPORT: 'store_report',
  /** 客户列表 */
  CUSTOMER_LIST: 'customer_list',
  /** 订单统计 */
  STORE_ORDER_STATISTICS: 'store_order_statistics',
  /** 商品统计 */
  STORE_PRODUCT_STATISTICS: 'store_product_statistics',
  /** 优惠券统计 */
  STORE_COUPON_STATISTICS: 'store_coupon_statistics',
  /** 分佣明细 */
  COMMISSION_DETAILS: 'commission_details',
  /** 分佣收益 */
  COMMISSION_INCOME: 'commission_income',
  /** 消费榜 */
  CONSUMPTION_RANK: 'consumption_rank',
  /** 团队业绩 */
  TEAM_PERFORMANCE: 'team_performance',
  /** 在途配送(门店报表) */
  TRANSIT_DELIVERY: 'transit_delivery',
  /** 代客下单 */
  AGENT_TAKE_ORDER: 'agent_take_order',
  /** 自助核销权限 */
  SELF_VERIFICATION_QRCODE: 'self_verification_qrcode',
  /** 战绩-门店报表-流量统计 */
  STORE_TRAFFIC_STATISTICS: 'store_traffic_statistics',
  /** 战绩-流量统计 */
  TRAFFIC_STATISTICS: 'traffic_statistics',
  /** 核销记录（门店报表） */
  VERIFICATION_RECORD_AGENT: 'verification_record_agent',
  /** 核销按钮 */
  VERIFICATION_BUTTON: 'verification_button',
  /** 代理自主改绑门店 */
  AGENTS_INDEPENDENTLY_BIND_STORES: 'agents_independently_bind_stores',
  /** 门店绑定提醒 */
  STORE_BINDING_REMINDER: 'store_binding_reminder',
  /** 社群接龙 */
  SOCIAL_COMMUNITY_FISSION: 'social_community_fission',
  /** 拉黑名单列表 */
  BLACK_LIST: 'blacklist',
  /** *
   * * 以下为生鲜场景下的权限code
   * */
  /** 客户管理 */
  FRESH_CUSTOMER_MANAGEMENT: 'fresh_customer_management',
  /** 消耗积分 */
  FRESH_CONSUME_POINTS: 'fresh_consume_points',
  /** 发送积分 */
  FRESH_SEND_POINTS: 'fresh_send_points',
  /** 拉黑 */
  FRESH_DEFRIEND: 'fresh_defriend',
  /** 禁言 */
  FRESH_FORBIDDEN_SPEECH: 'fresh_forbidden_speech',
  /** 解/换绑 */
  FRESH_UNBIND_OR_REPLACE_BINDING: 'fresh_unbind_or_replace_binding',
  /** 代客下单 */
  FRESH_AGENT_TAKE_ORDER: 'fresh_agent_take_order',
  /** 会员管理 */
  FRESH_CLUB: 'fresh_club',
  /** 会员审核 */
  FRESH_MEMBER_AUDIT: 'fresh_member_audit',
  /** 会员升降级 */
  FRESH_MENBER_PROMOTION_AND_DEMOTION: 'fresh_member_promotion_and_demotion',
  /** 会员移除 */
  FRESH_MEMBER_DELETE: 'fresh_member_delete',
  /** 代理码 */
  FRESH_CODE: 'fresh_code',
  /** 推广直播 */
  FRESH_LIVE: 'fresh_live',
  /** 推广商品 */
  FRESH_PICKS: 'fresh_picks',
  /** 推广团购 */
  FRESH_GROUP: 'fresh_group',
  /** 订单统计 */
  FRESH_ORDER_STATISTICS: 'fresh_order_statistics',
  /** 商品统计 */
  FRESH_PRODUCT_STATISTICS: 'fresh_product_statistics',
  /** 优惠券统计 */
  FRESH_COUPON_STATISTICS: 'fresh_coupon_statistics',
  /** 售后管理 */
  FRESH_CARE: 'fresh_care',
  /** 交易投诉 */
  FRESH_TRADING_COMPLAINTS: 'fresh_trading_complaints',
  /** 商品经营 */
  FRESH_OPERATIONS: 'fresh_operations',
  /** 发货单 */
  FRESH_DELIVERY_NOTE: 'fresh_delivery_note',
  /** 提货单 */
  FRESH_PICKUP_ORDER: 'fresh_pickup_order',
  /** 自助核销 */
  FRESH_SELF_VERIFICATION: 'fresh_self_verification',
  /** 核销记录 */
  FRESH_VERIFICATION_RECORD: 'fresh_verification_record',
  /** 核销按钮 */
  FRESH_VERIFICATION_BUTTON: 'fresh_verification_button',
  /** 门店报表 */
  FRESH_STORE_REPORT: 'fresh_store_report',
  /** 客户列表 */
  FRESH_CUSTOMER_LIST: 'fresh_customer_list',
  /** 订单统计 */
  FRESH_STORE_ORDER_STATISTICS: 'fresh_store_order_statistics',
  /** 商品统计 */
  FRESH_STORE_PRODUCT_STATISTICS: 'fresh_store_product_statistics',
  /** 优惠券统计 */
  FRESH_STORE_COUPON_STATISTICS: 'fresh_store_coupon_statistics',
  /** 分佣明细 */
  FRESH_COMMISSION_DETAILS: 'fresh_commission_details',
  /** 发货单 - 门店 */
  FRESH_STORE_DELIVERY_NOTE: 'fresh_store_delivery_note',
  /** 核销记录 */
  FRESH_VERIFICATION_RECORD_AGENT: 'fresh_verification_record_agent',
  /** 积分记录 */
  FRESH_RETAIL_POINTS_RECORD: 'fresh_retail_points_record',
  /** 业绩账户 */
  FRESH_PERFORMANCE_ACCOUNT: 'fresh_performance_account',
  /** 我的团队 */
  FRESH_TEAM_MANAGEMENT: 'fresh_team_management',
  /** 账户设置 */
  FRESH_ACCOUNT_SETTINGS: 'fresh_account_settings',
  /** 门店报表 */
  FRESH_OTHER_STORE_REPORT: 'fresh_other_store_report',
  /** 管理中心 */
  FRESH_MANAGEMENT_CENTER: 'fresh_management_center',
  /** 消息设置 */
  MSG_SETTING: 'msg_setting',
  /** 支付有礼 */
  FRESH_PAYMENT_BONUS: 'fresh_payment_bonus',
  /** 经营报表 */
  FRESH_OPERATION_REPORT: 'fresh_operation_report',
  /** 消费榜 */
  FRESH_CONSUMPTION_RANKING: 'fresh_consumption_ranking',
  /** 团队业绩 */
  FRESH_TEAM_PERFORMANCE: 'fresh_team_performance',
  /** 可用余额 */
  FRESH_AVAILABLE_BALANCE: 'fresh_available_balance',
  /** 集卡奖励 */
  FRESH_STAMP_REWARDS: 'fresh_stamp_rewards',
  /** 社群红包 */
  FRESH_COMMUNITY_REDPACKET: 'fresh_community_redpacket',
}

/** 结算类型 */
export const settleStatusOption = [
  { text: '全部', value: '-10' },
  { text: '已结算', value: '0' },
  { text: '待结算', value: '1' },
  { text: '已退款', value: '-1' },
  { text: '已结算退款(线上)', value: '-2' },
  { text: '结算终止', value: '-4' },
  { text: '已结算退款(线下)', value: '-6' },
  { text: '部分结算退款（线上）', value: '-7' },
]
